import { render, staticRenderFns } from "./Fiction.vue?vue&type=template&id=27cf8167&scoped=true"
import script from "./Fiction.vue?vue&type=script&lang=js"
export * from "./Fiction.vue?vue&type=script&lang=js"
import style0 from "./Fiction.vue?vue&type=style&index=0&id=27cf8167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf8167",
  null
  
)

export default component.exports